export default {
  message: {
    longPressSaveTips: '請長按圖片保存',
    noUser: '請輸入聯係人姓名/手機號/驗證碼',
    bookingSuccess: '預約成功',
    bookingFailed: '預約失敗',
    phoneNumInvalid: '請輸入有效的手機號碼！'
  },
  placeholder: {
    enter: '請輸入您喜歡的品牌'
  },
  activityInfo: {
    detail: '活動詳情'
  },
  fullScreenPhoto: {
    showPic: '顯示大圖',
    downloading: '下載中',
    fileName: '文件名',
    fileSize: '尺寸',
    category: '分類',
    authorName: '攝影師'
  },
  functionBar: {
    all: '全部',
    newest: '最新',
    hot: '人氣',
    category: '照片',
    video: '視頻',
    arrange: '排序',
    merge: '拼圖',
    
    video: '視頻'
  },
  imagewall: {
    cancel: '取消',
    merge: '拼圖',
    longPressSaveTips: '長按保存圖片',
    sweepAndShareTips: '掃一掃分享此相冊',
    product: '卡菲雲相冊',
    bookingTitle: '在綫預約',
    bookingContacts: '請輸入聯係人姓名（必填）',
    bookingPhoneNum: '請輸入手機號（必填）',
    bookingSmscode: '請輸入驗證碼（必填）',
    bookingGetSmscode: '獲取驗證碼',
    bookingRetrySmscode: '秒后重新獲取',
    bookingCompany: '請輸入公司名稱（選填）',
    bookingDetail: '請輸入拍攝需求，如時間、地點、活動規模等（選填）',
    bookingSubmit: '提交預約',

    selfieTitle: '自拍選圖',
    selfieTipsInit1: '請上傳單人正面照',
    selfieTipsInit2: '可快速查找相冊裏的照片',
    selfieTipsUploading: '正在識別中，請稍後...',
    selfieTipsFailed: '識別失敗',
    selfieUpload: '上傳照片',
    selfieReupload: '重新上傳照片'
  },
  welcome: {
    into: '進入相冊'
  }
}
